import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage.jsx";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps  
  const login = async (data) => {
    setUser(data);
    navigate("/home");
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const logout = () => {
    setUser(null);
    navigate("/", { replace: true });
    localStorage.clear();
    window.location.reload();
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [login, logout, user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
